import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../filters';
import users from '../../users';
import enquiriesTools from '@/employee/enquiries/enquiriesTools';

export default {
  name: 'customer',
  components: {
    DataGridComp: require('../../customcontrols/datagrid.vue').default,
    ChartComp: require('../../customcontrols/chart.vue').default,
    MasterDetailsGridsComp: require('../../customcontrols/master_details_grids.vue').default,
    CustomerPropertiesComp: require('./customerProperties.vue').default,
    inputWithCopy: require('../../common/inputWithCopy/inputWithCopy.vue').default,
    inputWithViewDetails: require('../../common/inputWithViewDetails/inputWithViewDetails.vue').default,
    reportsComp: require('../../common/reports/reports.vue').default,
    EmptyStates: require('@/customcontrols/emptyState/emptyState.vue').default,
    MenuListItem: require('@/employee/enquiries/menuListItem.vue').default,
  },
  mixins: [users, enquiriesTools],
  data: function () {
    return {
      menuVisible: true,
      propId: -1,
      pageInfo: {
        "pageNumber": 1,
        "pageSize": 10
      },
      custkey: '',
      customerName: '',
      propertyId: -1,
      property: null,
      lang: '',
      selectedTab: 'CustomerAllDetails',
      BillingMasterCustomer: false,
      settings: {},
      CustomerData:[],

      statmNo: 0,
      statmTransactions: {
        "Data": [],
        "Cols": [],
        "keyCol": "transNo",
        "totalRow": 0,
        "pageingOption": { pageSize: 10, total: 0, page: 1 }
      },

      loadPropertyData: false,

      customerAllData: null,

      lastInvoiveIssueDate: '',
      lastInvoiveIssueAmount: '',
      lastReadingDate: '',
      lastReading: '',

      showGeneralReportsDialog: false,
      showCustomerReportsDialog: false,
      generalReports: [],
      customerReports: [],
      properties: [],
      subCons: [],
      selectedAgreemNo: 0,
      queries: [],
      dgkeytransactions: 1,
      dgkeyAccountApplications: 1,
      dgkeyPropertiesApplications: 1,
      dgkeyDmCases: 1,
      dgkeyDmAgreements: 1,
      dgkeyDmInvestigations: 1,
      dgkeyDeposits: 1,
      dgkeyPropertyHistory: 1,
      dgkeyConnectionHistory: 1,
      dgkeyUnbilledTransactions: 1,
      dgkeyStatements: 1,
      dgkeyReadings: 1,
      selectedStatementId: null,
      tabs: {},
    }
  },
  created() {
    this.propId = this.$route.params.propertyId;
    this.custkey = this.$route.params.custkey;

    this.tabs = {
      AccountDetails: {
      label: this.$t('enquiriesAccount.AccountDetails'),
        icon: this.enqIcons.details.icon,
        show: false
      },
      CustomerAllDetails: {
        label: this.$t('enquiriesAccount.CustomerDetails'),
        icon: this.enqIcons.account.icon,
        show: true
      },
      CustomerDetails: {
        label: this.$t("enquiries.customer"),
        icon: this.enqIcons.person.icon,
        show: true
      },
      Properties: {
        label: this.$t("enquiries.properties"),
        icon: this.enqIcons.property.icon,
        show: true
      },
      Connections: {
        label: this.$t("enquiries.connection"),
        icon: this.enqIcons.connection.icon,
        show: false
      },

      Statements: {
        ...this.enqIcons.statements,
        show: true,
        expand: {
          Statements: {
            ...this.enqIcons.statements,
            show: true,
          },
          UnbilledTransactions: {
            ...this.enqIcons.unbilledTransactions,
            show: true,
          },
          Transactions: {
            ...this.enqIcons.transactions,
            show: true,
          },
        }
      },

      Readings: {
        ...this.enqIcons.readings,
        show: false,
        expand: {
          Readings: {
            ...this.enqIcons.readings,
            show: true,
          },
          Consumption: {
            label: this.$t('enquiries.consumptions'),
            icon: this.enqIcons.consumption.icon,
            show: true,
          },
          ReadingGraph: {
            label: this.$t('enquiries.readingsGraph'),
            icon: this.enqIcons.barChart.icon,
            show: true,
          },
        }
      },

      Applications: {
        ...this.enqIcons.applications,
        show: true,
        expand: {
          AccountApplications: {
            label: this.$t('enquiries.accountApplications'),
            icon: this.enqIcons.account.icon,
            show: true,
          },
          PropertiesApplications: {
            label: this.$t('enquiries.propertyApplications'),
            icon: this.enqIcons.dottedHouse.icon,
            show: true,
          },
        }
      },

      DebtManagement: {
        ...this.enqIcons.debtManagement,
        show: true,
        expand: {
          DmCases: {
            label: this.$t('enquiries.dmCases'),
            icon: this.enqIcons.cases.icon,
            show: true,
          },
          DmAgreements: {
            label: this.$t('enquiries.dmAgreements'),
            icon: this.enqIcons.agreement.icon,
            show: true,
          },
          DmInvestigations: {
            label: this.$t('enquiries.dmInvestigations'),
            icon: this.enqIcons.investigation.icon,
            show: true,
          },
          Deposits: {
            ...this.enqIcons.deposits,
            show: true,
          },
        }
      },

      History: {
        ...this.enqIcons.history,
        show: true,
        expand: {
          PropertyHistory: {
            label: this.$t('enquiries.propertyHistory'),
            icon: this.enqIcons.property.icon,
            show: true,
          },
          ConnectionHistory: {
            label: this.$t('enquiries.connectionHistory'),
            icon: this.enqIcons.connection.icon,
            show: true,
          },
        }
      },

    };
    this.CustomerData = [
      {
        idx: "CustomerAllDetails",
        title: this.tabs.CustomerAllDetails.label,
        icon: this.tabs.CustomerAllDetails.icon,
        loading: false,
        ControlType: "Custom",
        Data: [],
        Cols: [],
        keyCol: "",
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
      },
      {
        idx: "Transactions",
        title: this.tabs.Statements.expand.Transactions.label,
        icon: this.tabs.Statements.expand.Transactions.icon,
        loading: false,
        ControlType: "Grid",
        Data: [],
        Cols: [],
        keyCol: "transNo",
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
      },
      {
        idx: "CustomerDetails",
        title: this.tabs.CustomerDetails.label,
        icon: this.tabs.CustomerDetails.icon,
        loading: false,
        ControlType: "Table",
        Data: [],
        Cols: [],
        keyCol: "",
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
      },
      {
        idx: "AccountDetails",
        title: this.tabs.AccountDetails.label,
        icon: this.tabs.AccountDetails.icon,
        loading: false,
        ControlType: "Table",
        Data: [],
        Cols: [],
        keyCol: "",
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
      },
      {
        idx: "Properties",
        title: this.tabs.Properties.label,
        icon: this.tabs.Properties.icon,
        loading: false,
        ControlType: "propertiesComp",
        Data: null,
        Cols: [],
        keyCol: "propRef",
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
      },
      {
        idx: "Connections",
        title: this.tabs.Connections.label,
        icon: this.tabs.Connections.icon,
        loading: false,
        ControlType: "Table",
        Data: [],
        Cols: [],
        keyCol: "",
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
      },
      {
        idx: "AccountApplications",
        title: this.tabs.Applications.expand.AccountApplications.label,
        icon: this.tabs.Applications.expand.AccountApplications.icon,
        loading: false,
        ControlType: "Grid",
        Data: [],
        Cols: [],
        keyCol: "applicationId",
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
      },
      {
        idx: "PropertiesApplications",
        title: this.tabs.Applications.expand.PropertiesApplications.label,
        icon: this.tabs.Applications.expand.PropertiesApplications.icon,
        loading: false,
        ControlType: "Grid",
        Data: [],
        Cols: [],
        keyCol: "applicationId",
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
      },
      {
        idx: "DmCases",
        title: this.tabs.DebtManagement.expand.DmCases.label,
        icon: this.tabs.DebtManagement.expand.DmCases.icon,
        loading: false,
        ControlType: "Grid",
        Data: [],
        Cols: [],
        keyCol: "caseId",
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
      },
      {
        idx: "DmAgreements",
        title: this.tabs.DebtManagement.expand.DmAgreements.label,
        icon: this.tabs.DebtManagement.expand.DmAgreements.icon,
        loading: false,
        ControlType: "Grid",
        Data: [],
        Cols: [],
        keyCol: "reference",
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
      },
      {
        idx: "DmInvestigations",
        title: this.tabs.DebtManagement.expand.DmInvestigations.label,
        icon: this.tabs.DebtManagement.expand.DmInvestigations.icon,
        loading: false,
        ControlType: "Grid",
        Data: [],
        Cols: [],
        keyCol: "id",
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
      },
      {
        idx: "Deposits",
        title: this.tabs.DebtManagement.expand.Deposits.label,
        icon: this.tabs.DebtManagement.expand.Deposits.icon,
        loading: false,
        ControlType: "Grid",
        Data: [],
        Cols: [],
        keyCol: "custkey",
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
      },
      {
        idx: "PropertyHistory",
        title: this.tabs.History.expand.PropertyHistory.label,
        icon: this.tabs.History.expand.PropertyHistory.icon,
        loading: false,
        ControlType: "Grid",
        Data: [],
        Cols: [],
        keyCol: "docNo",
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
      },
      {
        idx: "ConnectionHistory",
        title: this.tabs.History.expand.ConnectionHistory.label,
        icon: this.tabs.History.expand.ConnectionHistory.icon,
        loading: false,
        ControlType: "Grid",
        Data: [],
        Cols: [],
        keyCol: "applicationId",
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
      },
      {
        idx: "UnbilledTransactions",
        title: this.tabs.Statements.expand.UnbilledTransactions.label,
        icon: this.tabs.Statements.expand.UnbilledTransactions.icon,
        loading: false,
        ControlType: "Grid",
        Data: [],
        Cols: [],
        keyCol: "transNoAbs",
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
      },
      {
        idx: "Statements",
        title: this.tabs.Statements.expand.Statements.label,
        icon: this.tabs.Statements.expand.Statements.icon,
        loading: false,
        ControlType: "Grid",
        Data: [],
        Cols: [],
        keyCol: "statementId",
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
      },
      {
        idx: "Readings",
        title: this.tabs.Readings.expand.Readings.label,
        icon: this.tabs.Readings.expand.Readings.icon,
        loading: false,
        ControlType: "Grid",
        Data: [],
        Cols: [],
        keyCol: "userReadingNo",
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
      },
      {
        idx: "Consumption",
        title: this.tabs.Readings.expand.Consumption.label,
        icon: this.tabs.Readings.expand.Consumption.icon,
        loading: false,
        ControlType: "Chart",
        Data: [],
        arg_field: "rdgDate",
        value_field: "consumption",
        chart_type: "bar",
        Cols: [],
        keyCol: "",
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
      },
      {
        idx: "ReadingGraph",
        title: this.tabs.Readings.expand.ReadingGraph.label,
        icon: this.tabs.Readings.expand.ReadingGraph.icon,
        loading: false,
        ControlType: "Chart",
        Data: [],
        arg_field: "rdgDate",
        value_field: "consumption",
        chart_type: "line",
        Cols: [],
        keyCol: "",
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
      },
    ];

    this.findDefaultTab(true);
    this.fillGridsColumns();
  },
  mounted() {
    this.getSettings();
    this.getCustomerAllDetails();
    this.getQueries();
  },
  computed: {
    propertyDescription: function () {
      return this.$t('enquiries.currentPropertyLabel') + ': ' + this.property.propRef;
    },
    selectedTabObj: function () {     
      switch (this.selectedTab) {
        case 'Transactions':
          return this.tabs.Statements.expand[this.selectedTab];
        case 'UnbilledTransactions':
          return this.tabs.Statements.expand[this.selectedTab];

        case 'Consumption':
          return this.tabs.Readings.expand[this.selectedTab];
        case 'ReadingGraph':
          return this.tabs.Readings.expand[this.selectedTab];

        case 'AccountApplications':
          return this.tabs.Applications.expand[this.selectedTab];
        case 'PropertiesApplications':
          return this.tabs.Applications.expand[this.selectedTab];

        case 'DmCases':
          return this.tabs.DebtManagement.expand[this.selectedTab];
        case 'DmAgreements':
          return this.tabs.DebtManagement.expand[this.selectedTab];
        case 'DmInvestigations':
          return this.tabs.DebtManagement.expand[this.selectedTab];
        case 'Deposits':
          return this.tabs.DebtManagement.expand[this.selectedTab];

        case 'PropertyHistory':
          return this.tabs.History.expand[this.selectedTab];
        case 'ConnectionHistory':
          return this.tabs.History.expand[this.selectedTab];           
        default:
          return this.tabs[this.selectedTab];
      }
    },
    connTableData: function () {
      let data = this.CustomerData.filter(a => a.idx == 'Connections')[0].Data.
        filter(a => a.title != 'connId' && a.title != 'mainConnId' && a.title != 'meterId');

      let arr = [], indx = 1, i = 1;

      for (i; i < data.length; i++) {
        if (data[i].title == 'connNo') {
          arr.push({ data: data.slice(i - indx, i), id: arr.length });
          indx = 1;
        }
        else
          indx++;
      }

      arr.push({ data: data.slice(i - indx, i), id: arr.length });

      //console.log("connTableData", arr);
      return arr;
    },
  },
  watch: {
    propertyId: function (val) {
      this.getConnection();
      this.getPropertyApplications();
      this.getDmCases();
      this.getDmAgreements();
      this.getDmInvestigations();
      this.getDeposits();
      this.getPropertyHistory();
      this.getConnectionHistory();
      this.getUnbilledTransaction();
      this.getReadings();
      this.getReadingsGraph();
      this.getReadingsConsumption();
      this.getStatements();
    },
    selectedTab: function (val) {
      switch (val) {
        default:
          this.$root.$emit(`refresh_data_grid:${val}DataGrid`);
          break;
      }

      //console.log("selectedTab", val, this.CustomerData.filter(a => a.idx == val)[0])
      if (this[`dgkey${val}`])
        this[`dgkey${val}`] += 1;

      this.changeUrl(val);
    },
  },
  methods: {
    getSettings() {
      axios.post('/Utility/GetSettings')
        .then(response => {
          if (response.status == 200) {
            this.settings = response.data.value;

            if (this.settings && !this.settings.showOwnedProperties) {
              this.tabs.Connections.show = true;
              this.tabs.Readings.show = true;
            }
            else {
              this.tabs.Connections.show = false;
              this.tabs.Readings.show = false;
            }
          }
        })
        .catch(e => { this.getDataFailed(); })
    },
    changeSelectedTab(idx) {
      this.selectedTab = idx;
    },

    getCustomerAllDetails() {
      this.CustomerData.filter(a => a.idx == 'CustomerAllDetails')[0].loading = true;
      this.customerAllData = null;

      var parameters = {
        custkey: this.custkey,
        loginEmail: this.getLoginName(),
        Options: { pageSize: 10, total: 0, page: 1 }
      }

      axios.post('/Enquiries/getCustomerAllDetails', parameters)
        .then(response => {
          //console.log('response', response);
          if (response.data.data.status == 0) {
            //console.log('getCustomerAllDetails', response.data);

            this.getProperties(response.data.custData.custkey);

            if (response.data.custData.hasConnection) {
              response.data.custData.connection.connDate = moment(response.data.custData.connection.connDate).format('DD/MM/YYYY');
            }

            this.customerAllData = response.data.custData;

            this.getCustomerDetails();
            this.getAccountDetails();
            this.getAccountApplications();
            this.getTransactions();

            this.getCustomerReports();
            this.getGeneralReports();
            this.getSubConnections();
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed(e);
          this.$oldAlertMsg(e, 4);
        })
        .finally(() => this.CustomerData.filter(a => a.idx == 'CustomerAllDetails')[0].loading = false);
    },
    getProperties(custkey) {
      var parameters = {
        custkey: custkey,
        loginEmail: this.getLoginName(),
        Options: { pageSize: 10, total: 0, page: 1 }
      }

      axios.post('/Enquiries/getProperties', parameters)
        .then(response => {
          if (response.status == 200) {
            this.properties = response.data.items;
            if (response.data.items.length > 0) {
              this.property = response.data.items[0];
              this.propertyId = this.propId == -1 ? response.data.items[0].propertyId : this.propId;
            }
          }
          else
            this.getDataFailed();
        })
        .catch(e => { this.getDataFailed(e) })
    },
    tableDoubleClick(selectedTab) {
      if (selectedTab == 'CustomerDetails' || selectedTab == 'AccountDetails')
        this.customerDetails();
      else if (selectedTab == 'Connections')
        this.connectionDetails();
    },

    customerDetails() {
      //let routeData = this.$router.resolve({ name: 'customerDetails', params: { CUSTKEY: this.custkey } });
      //window.open(routeData.href, '_blank');
    },

    connectionDetails() {
      var ConnId = this.CustomerData.filter(a => a.idx == 'Connections')[0].Data.filter(a => a.title == 'connId')[0].description;

      let routeData = this.$router.resolve({ name: 'connectionDetails', params: { ConnectionId: ConnId } });
      window.open(routeData.href, '_blank');
    },

    meterDetails(info) {
      let routeData = this.$router.resolve({ name: 'property_details', query: { data: "someData" } });
      window.open(routeData.href, '_blank');
    },

    //GRID PAGE CHANGE
    gridPageChange(pInfo) {
      this.pageInfo = pInfo;
      let selectedPinfo = this.CustomerData.filter(a => a.idx == this.selectedTab)[0].pageingOption;
      if (selectedPinfo.page == pInfo.pageNumber && selectedPinfo.pageSize == pInfo.pageSize)
        return;

      this.CustomerData.filter(a => a.idx == this.selectedTab)[0].pageingOption.page = pInfo.pageNumber;
      this.CustomerData.filter(a => a.idx == this.selectedTab)[0].pageingOption.pageSize = pInfo.pageSize;

      this.fillPageData();
    },
    fillPageData() {
      if (this.selectedTab == 'AccountApplications')
        this.getAccountApplications(false);
      else if (this.selectedTab == 'PropertiesApplications')
        this.getPropertyApplications(false);
      else if (this.selectedTab == 'DmCases')
        this.getDmCases(false);
      else if (this.selectedTab == 'DmAgreements')
        this.getDmAgreements(false);
      else if (this.selectedTab == 'DmInvestigations')
        this.getDmInvestigations(false);
      else if (this.selectedTab == 'Deposits')
        this.getDeposits(false);
      else if (this.selectedTab == 'PropertyHistory')
        this.getPropertyHistory(false);
      else if (this.selectedTab == 'ConnectionHistory')
        this.getConnectionHistory(false);
      else if (this.selectedTab == 'UnbilledTransactions')
        this.getUnbilledTransaction(false);
      else if (this.selectedTab == 'Readings')
        this.getReadings(false);
      else if (this.selectedTab == 'Statements')
        this.getStatements(false);
      else if (this.selectedTab == 'Transactions')
        this.getTransactions(false);
    },
    PropertiesPageChanging(pInfo) {
      this.CustomerData.filter(a => a.idx == 'Properties')[0].pageingOption.page = pInfo.pageNumber;
      this.CustomerData.filter(a => a.idx == 'Properties')[0].pageingOption.pageSize = pInfo.pageSize;

      //this.getProperties();
    },

    selectProperty(propId, prop) {
      if (propId == this.propertyId)
        return;

      this.property = prop;
      this.propertyId = propId;
    },
    showPropertyDetails(info) {
      let routeData = this.$router.resolve({ name: 'propertyDetails', params: { PROPERTYID: info.data.propertyId } });
      window.open(routeData.href, '_blank');
    },
    showReadingDetails(info) {
      let routeData = this.$router.resolve({ name: 'readingDetails', query: { ConnectionId: info.data.connectionId, MeterId: info.data.meterId, ReadingNo: info.data.readingNo } });
      window.open(routeData.href, '_blank');
    },

    getTransactions(loader = true) {
      if (loader)
        this.CustomerData.filter(a => a.idx == 'Transactions')[0].loading = true;

      var parameters = {
        custkey: this.custkey,
        loginEmail: this.getLoginName(),
        Options: this.CustomerData.filter(a => a.idx == 'Transactions')[0].pageingOption
      }

      axios.post('/Enquiries/getCustomerTransactions', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            this.CustomerData.filter(a => a.idx == 'Transactions')[0].Data = response.data.items;

            this.CustomerData.filter(a => a.idx == 'Transactions')[0].totalRow = response.data.itemsCount;
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text), 4;
          }
        })
        .catch(e => {
          this.getDataFailed(e);
          this.$oldAlertMsg(e, 4);
        })
        .finally(() => this.CustomerData.filter(a => a.idx == 'Transactions')[0].loading = false);
    },

    getAccountApplications(loader = true) {
      if (loader)
      this.CustomerData.filter(a => a.idx == 'AccountApplications')[0].loading = true;

      var parameters = {
        custkey: this.custkey,
        loginEmail: this.getLoginName(),
        Options: this.CustomerData.filter(a => a.idx == 'AccountApplications')[0].pageingOption
      }

      axios.post('/Enquiries/getAccountApplications', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            this.CustomerData.filter(a => a.idx == 'AccountApplications')[0].Data = response.data.items;

            this.CustomerData.filter(a => a.idx == 'AccountApplications')[0].totalRow = response.data.itemsCount;
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text,4);
          }
        })
        .catch(e => {
          this.getDataFailed();
          this.$oldAlertMsg(e, 4);
        })
        .finally(() => this.CustomerData.filter(a => a.idx == 'AccountApplications')[0].loading = false);
    },

    getCustomerDetails() {
      this.CustomerData.filter(a => a.idx == 'CustomerDetails')[0].loading = true;

      var parameters = {
        custkey: this.custkey,
        loginEmail: this.getLoginName(),
        Options: { pageSize: 10, total: 0, page: 1 }
      }

      axios.post('/Enquiries/getCustomerDetails', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            //console.log('getCustomerDetails', response.data);
            if (response.data.items && response.data.items.length > 0)
            response.data.items.forEach(d => {
              if (d && d.description)
                d.description = d.description.trim()
            });
            this.CustomerData.filter(a => a.idx == 'CustomerDetails')[0].Data = response.data.items;
            this.customerName = response.data.items.filter(a => a.title == 'Name').length == 0 ? '' : response.data.items.filter(a => a.title == 'Name')[0].description;
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed();
          this.$oldAlertMsg(e, 4);
        })
        .finally(() =>  this.CustomerData.filter(a => a.idx == 'CustomerDetails')[0].loading = false);
    },
    getAccountDetails() {
      this.CustomerData.filter(a => a.idx == 'AccountDetails')[0].loading = true;

      var parameters = {
        custkey: this.custkey,
        loginEmail: this.getLoginName(),
        Options: { pageSize: 10, total: 0, page: 1 }
      }

      axios.post('/Enquiries/getAccountDetails', parameters)
        .then(response => {
          //console.log('getAccountDetails', response.data);
          if (response.data.data.status == 0) {
            this.CustomerData.filter(a => a.idx == 'AccountDetails')[0].Data = response.data.items;
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.$oldAlertMsg(e, 4);
        })
        .finally(() => this.CustomerData.filter(a => a.idx == 'AccountDetails')[0].loading = false);
    },
    getConnection() {
      this.CustomerData.filter(a => a.idx == 'Connections')[0].loading = true;

      var parameters = {
        prop: this.property,
        loginEmail: this.getLoginName(),
        Options: { pageSize: 10, total: 0, page: 1 }
      }

      axios.post('/Enquiries/getPropertyConnection', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            this.CustomerData.filter(a => a.idx == 'Connections')[0].Data = response.data.items;

            //this.CustomerData.filter(a => a.idx == 'Connections')[0].Data
            //  .push({
            //    title: "seq",
            //    subTitle: null,
            //    description: this.customerAllData.seq,
            //    propertyId: response.data.items[0].propertyId
            //  })

            this.CustomerData.filter(a => a.idx == 'Connections')[0].totalRow = response.data.itemsCount;
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed();
          this.$oldAlertMsg(e, 4);
        })
        .finally(() => this.CustomerData.filter(a => a.idx == 'Connections')[0].loading = false);
    },
    getPropertyApplications(loader = true) {
      if (loader)
      this.CustomerData.filter(a => a.idx == 'PropertiesApplications')[0].loading = true;

      var parameters = {
        propertyId: this.propertyId,
        loginEmail: this.getLoginName(),
        Options: this.CustomerData.filter(a => a.idx == 'PropertiesApplications')[0].pageingOption
      }

      axios.post('/Enquiries/getPropertyApplications', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            this.CustomerData.filter(a => a.idx == 'PropertiesApplications')[0].Data = response.data.items;

            this.CustomerData.filter(a => a.idx == 'PropertiesApplications')[0].totalRow = response.data.itemsCount;
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed();
          this.$oldAlertMsg(e,4);
        })
        .finally(() => this.CustomerData.filter(a => a.idx == 'PropertiesApplications')[0].loading = false);
    },
    getDmCases(loader = true) {
      if (loader)
      this.CustomerData.filter(a => a.idx == 'DmCases')[0].loading = true;

      var parameters = {
        custkey: this.custkey,
        propertyId: this.propertyId,
        loginEmail: this.getLoginName(),
        Options: this.CustomerData.filter(a => a.idx == 'DmCases')[0].pageingOption
      }

      axios.get('/Enquiries2/GetDmCases?account=' + this.custkey + '&page=' + this.CustomerData.filter(a => a.idx == 'DmCases')[0].pageingOption.page + '&pageSize=' + this.CustomerData.filter(a => a.idx == 'DmCases')[0].pageingOption.pageSize)
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.CustomerData.filter(a => a.idx == 'DmCases')[0].Data = response.data.items;

            this.CustomerData.filter(a => a.idx == 'DmCases')[0].totalRow = response.data.itemsCount;
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed(e);
          this.$oldAlertMsg(e, 4);
        })
        .finally(() => this.CustomerData.filter(a => a.idx == 'DmCases')[0].loading = false);
    },
    getDmAgreements(loader = true) {
      if (loader)
      this.CustomerData.filter(a => a.idx == 'DmAgreements')[0].loading = true;

      var parameters = {
        custkey: this.custkey,
        propertyId: this.propertyId,
        loginEmail: this.getLoginName(),
        Options: this.CustomerData.filter(a => a.idx == 'DmAgreements')[0].pageingOption
      }

      axios.post('/Enquiries/getCustomerDmAgreements', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            this.CustomerData.filter(a => a.idx == 'DmAgreements')[0].Data = response.data.items;

            this.CustomerData.filter(a => a.idx == 'DmAgreements')[0].totalRow = response.data.itemsCount;
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed(e);
          this.$oldAlertMsg(e, 4);
        })
        .finally(() => this.CustomerData.filter(a => a.idx == 'DmAgreements')[0].loading = false);
    },
    getDmInvestigations(loader = true) {
      if (loader)
      this.CustomerData.filter(a => a.idx == 'DmInvestigations')[0].loading = true;

      var parameters = {
        custkey: this.custkey,
        propertyId: this.propertyId,
        loginEmail: this.getLoginName(),
        Options: this.CustomerData.filter(a => a.idx == 'DmInvestigations')[0].pageingOption
      }

      axios.post('/Enquiries/getDmInvestigations', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            this.CustomerData.filter(a => a.idx == 'DmInvestigations')[0].Data = response.data.items;

            this.CustomerData.filter(a => a.idx == 'DmInvestigations')[0].totalRow = response.data.itemsCount;
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed(e);
          this.$oldAlertMsg(e, 4);
        })
        .finally(() => this.CustomerData.filter(a => a.idx == 'DmInvestigations')[0].loading = false);
    },
    getDeposits(loader = true) {
      if (loader)
      this.CustomerData.filter(a => a.idx == 'Deposits')[0].loading = true;

      var parameters = {
        custkey: this.custkey,
        propertyId: this.propertyId,
        loginEmail: this.getLoginName(),
        Options: this.CustomerData.filter(a => a.idx == 'Deposits')[0].pageingOption
      }

      axios.post('/Enquiries/getDeposits', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            if (response.data.data.status == 0) {
              if (response.data.items && response.data.items.length > 0) {
                response.data.items.forEach(i => {
                  i.amount = this.$options.filters.twoDecimals(i.amount);
                  i.refunded = this.$options.filters.twoDecimals(i.refunded);
                });
              }

              this.CustomerData.filter(a => a.idx == 'Deposits')[0].Data = response.data.items;

              this.CustomerData.filter(a => a.idx == 'Deposits')[0].totalRow = response.data.itemsCount;
            }
            else {
              this.getDataFailed();
              this.$oldAlertMsg(response.data.data.text, 4);
            }
          }
        })
        .catch(e => {
          this.getDataFailed(e);
          this.$oldAlertMsg(e, 4);
        })
        .finally(() => this.CustomerData.filter(a => a.idx == 'Deposits')[0].loading = false);
    },
    getPropertyHistory(loader = true) {
      if (loader)
      this.CustomerData.filter(a => a.idx == 'PropertyHistory')[0].loading = true;

      var parameters = {
        propertyId: this.propertyId,
        loginEmail: this.getLoginName(),
        Options: this.CustomerData.filter(a => a.idx == 'PropertyHistory')[0].pageingOption
      }

      axios.post('/Enquiries/getPropertyHistory', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            this.CustomerData.filter(a => a.idx == 'PropertyHistory')[0].Data = response.data.items;

            this.CustomerData.filter(a => a.idx == 'PropertyHistory')[0].totalRow = response.data.itemsCount;
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed();
          this.$oldAlertMsg(e, 4);
          //this.$router.push('/login');
        })
        .finally(() => this.CustomerData.filter(a => a.idx == 'PropertyHistory')[0].loading = false);

    },
    getConnectionHistory(loader = true) {
      if (loader)
      this.CustomerData.filter(a => a.idx == 'ConnectionHistory')[0].loading = true;

      var parameters = {
        propertyId: this.propertyId,
        connectionId: 0,
        loginEmail: this.getLoginName(),
        Options: this.CustomerData.filter(a => a.idx == 'ConnectionHistory')[0].pageingOption
      }

      axios.post('/Enquiries/getConnectionHistory', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            this.CustomerData.filter(a => a.idx == 'ConnectionHistory')[0].Data = response.data.items;

            this.CustomerData.filter(a => a.idx == 'ConnectionHistory')[0].totalRow = response.data.itemsCount;
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed();
          this.$oldAlertMsg(e, 4);
          //this.$router.push('/login');
        })
        .finally(() => this.CustomerData.filter(a => a.idx == 'ConnectionHistory')[0].loading = false);
    },
    getUnbilledTransaction(loader = true) {
      if (loader)
      this.CustomerData.filter(a => a.idx == 'UnbilledTransactions')[0].loading = true;

      var parameters = {
        custkey: this.custkey,
        propertyId: this.propertyId,
        loginEmail: this.getLoginName(),
        Options: this.CustomerData.filter(a => a.idx == 'UnbilledTransactions')[0].pageingOption
      }

      axios.post('/Enquiries/getUnbilledTransaction', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            this.CustomerData.filter(a => a.idx == 'UnbilledTransactions')[0].Data = response.data.items;

            this.CustomerData.filter(a => a.idx == 'UnbilledTransactions')[0].totalRow = response.data.itemsCount;
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed();
          this.$oldAlertMsg(e, 4);
        })
        .finally(() => this.CustomerData.filter(a => a.idx == 'UnbilledTransactions')[0].loading = false);
    },
    getReadings(loader = true) {
      if (loader)
      this.CustomerData.filter(a => a.idx == 'Readings')[0].loading = true;

      var parameters = {
        prop: this.property,
        loginEmail: this.getLoginName(),
        Options: this.CustomerData.filter(a => a.idx == 'Readings')[0].pageingOption
      }

      axios.post('/Enquiries/getPropertyReadings', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            if (response.data.items && response.data.items.length > 0)
              response.data.items.forEach(i => i['readingNoAbs'] = Math.abs(i.readingNo));

            this.CustomerData.filter(a => a.idx == 'Readings')[0].Data = response.data.items;

            this.CustomerData.filter(a => a.idx == 'Readings')[0].totalRow = response.data.itemsCount;

            this.getLastReadingData();
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed();
          this.$oldAlertMsg(e, 4);
        })
        .finally(() => this.CustomerData.filter(a => a.idx == 'Readings')[0].loading = false);
    },
    getReadingsGraph() {
      this.CustomerData.filter(a => a.idx == 'ReadingGraph')[0].loading = true;

      var parameters = {
        prop: this.property,
        loginEmail: this.getLoginName(),
        Options: { pageSize: 10, total: 0, page: 1 }
      }

      axios.post('/Enquiries/getPropertyReadingsGraph', parameters)
        .then(response => {
          if (response.data.data.status == 0) {

            let _Readings = response.data.items;

            for (let i = 0; i < _Readings.length; i++) {
              this.CustomerData.filter(a => a.idx == 'ReadingGraph')[0].Data.push({ MeterRef: _Readings[i].MeterRef, consumption: _Readings[i].reading, rdgDate: this.$options.filters.formatDateDDMMYYY(_Readings[i].rdgDate) });
            }
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed();
          this.$oldAlertMsg(e, 4);
        })
        .finally(() => this.CustomerData.filter(a => a.idx == 'ReadingGraph')[0].loading = false);
    },
    getReadingsConsumption() {
      this.CustomerData.filter(a => a.idx == 'Consumption')[0].loading = true;

      var parameters = {
        prop: this.property,
        loginEmail: this.getLoginName(),
        Options: { pageSize: 10, total: 0, page: 1 }
      }

      axios.post('/Enquiries/getPropertyReadingsConsumptions', parameters)
        .then(response => {
          if (response.data.data.status == 0) {

            let _Consumption = response.data.items;

            for (let i = 0; i < response.data.items.length; i++) {
              this.CustomerData.filter(a => a.idx == 'Consumption')[0].Data.push({ MeterRef: _Consumption[i].meterRef, consumption: _Consumption[i].consumption, rdgDate: this.$options.filters.formatDateDDMMYYY(_Consumption[i].rdgDate) });
            }
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed(e);
          this.$oldAlertMsg(e, 4);
        })
        .finally(() => this.CustomerData.filter(a => a.idx == 'Consumption')[0].loading = false);
    },
    getStatements(loader = true) {
      if (loader)
        this.CustomerData.filter(a => a.idx == 'Statements')[0].loading = true;

      let opt = this.CustomerData.filter(a => a.idx == 'Statements')[0].pageingOption;

      //console.log("cust", this.CustomerData)
      axios.get('/Enquiries2/GetStatements?account=' + this.custkey + '&page=' + opt.page + '&pageSize=' + opt.pageSize)
        .then(response => {
          if (response.status == 200) {
            //console.log("response", response)
            if (response.data.items && response.data.items.length > 0) 
              response.data.items.forEach(i => {
                i['statementNoAbs'] = Math.abs(i.statementNo);
                i['invoiceNoAbs'] = Math.abs(i.invoiceNo);

                if (i.transactions && i.transactions.length > 0)
                  i.transactions.forEach(t => {
                    t['transactionIdAbs'] = Math.abs(t.transactionId);
                    t['statementIdAbs'] = Math.abs(t.statementId);
                  });
              });            

            this.CustomerData.filter(a => a.idx == 'Statements')[0].Data = response.data.items;

            this.CustomerData.filter(a => a.idx == 'Statements')[0].totalRow = response.data.itemsCount;

            this.CustomerData.filter(a => a.idx == 'Statements')[0].loading = false;

            this.getLastInvoiceData();           
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed(e);
          this.$oldAlertMsg(e, 4);
        })
        .finally(() => this.CustomerData.filter(a => a.idx == 'Statements')[0].loading = false);
    },

    getStatementTransactions(info) {
      //console.log(info);

      if (info)
        this.selectedStatementId = info.rows[info.newRowIndex].data.statementId;

      if (this.selectedStatementId == null)
        return;

      var parameters = {
        custkey: this.custkey,
        propertyId: this.propertyId,
        loginEmail: this.getLoginName(),
        Options: { pageSize: this.statmTransactions.pageingOption.pageSize, page: this.statmTransactions.pageingOption.page },
        StatementId: this.selectedStatementId,
      }
      //console.log("param", parameters);
      // console.log("state", info.rows[info.newRowIndex].data.statementId)
      axios.post('/Enquiries/getUnbilledTransaction', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            this.statmTransactions.Data = response.data.items;

            this.statmTransactions.totalRow = response.data.itemsCount;

          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed(e);
          this.$oldAlertMsg(e, 4);
        });
    },
    transPageChange(pInfo) {
      console.log("ddd", pInfo)
      if (this.statmTransactions.pageingOption.page == pInfo.pageNumber && this.statmTransactions.pageingOption.pageSize == pInfo.pageSize)
        return;

      this.statmTransactions.pageingOption.page = pInfo.pageNumber;
      this.statmTransactions.pageingOption.pageSize = pInfo.pageSize;

      this.getStatementTransactions();
    },

    fillGridsColumns() {
      this.fillPropertyColumns();
      this.fillAccountApplicationsColumns();
      this.fillPropertyApplicationsColumns();
      this.fillDmCasesColumns();
      this.fillDmAgreementsColumns();
      this.fillDmInvestigationsColumns();
      this.fillDepositsColumns();
      this.fillPropertyHistoryColumns();
      this.fillConnectionHistoryColumns();
      this.fillUnbilledTransactionsColumns();
      this.fillStatementsColumns();
      this.fillReadingsColumns();
      this.fillTransactionsColumns();
    },
    fillPropertyColumns() {
      this.CustomerData.filter(a => a.idx == 'Properties')[0].Cols = [];

      let Cols = [];

      Cols.push({ dataField: 'town', caption: this.$t('enquiriesAccount.town') });
      Cols.push({ dataField: 'township', caption: this.$t('enquiriesAccount.township') });
      Cols.push({ dataField: 'plotNo', caption: this.$t('enquiriesAccount.plotNo') });
      Cols.push({ dataField: 'propRef', caption: this.$t('enquiriesAccount.propRef') });
      Cols.push({ dataField: 'billingGroup', caption: this.$t('enquiriesAccount.billingGroup') });
      Cols.push({ dataField: 'custkey', caption: this.$t('enquiriesAccount.custkey') });
      Cols.push({ dataField: 'tenantIdNo', caption: this.$t('enquiriesAccount.tenantIdNo') });
      Cols.push({ dataField: 'ownerCustkey', caption: this.$t('enquiriesAccount.ownerCustkey') });
      Cols.push({ dataField: 'ownerIdNo', caption: this.$t('enquiriesAccount.ownerIdNo') });
      Cols.push({ dataField: 'propertyAddress', caption: this.$t('enquiriesAccount.propertyAddress') });
      Cols.push({ dataField: 'propertyBuildingName', caption: this.$t('enquiriesAccount.propertyBuildingName') });
      Cols.push({ dataField: 'applicationCount', caption: this.$t('enquiriesPropertyDetails.applications') });
      Cols.push({ dataField: 'waterService', caption: this.$t('enquiriesAccount.waterService') });
      Cols.push({ dataField: 'sewerService', caption: this.$t('enquiriesAccount.sewerService') });
      Cols.push({ dataField: 'electricityService', caption: this.$t('enquiriesPropertyDetails.Electricity') });
      Cols.push({ dataField: 'propConsumptionType', caption: this.$t('enquiriesAccount.propConsumptionType') });
      Cols.push({ dataField: 'licenseNo', caption: this.$t('enquiriesPropertyDetails.licenseNo') });
      Cols.push({ dataField: 'licenseStatus', caption: this.$t('enquiriesPropertyDetails.licenseStatus') });
      Cols.push({ dataField: 'waterTariff', caption: this.$t('enquiriesAccount.waterTariff') });
      Cols.push({ dataField: 'sewerTariff', caption: this.$t('enquiriesAccount.sewerTariff') });
      Cols.push({ dataField: 'electricityTariff', caption: this.$t('enquiriesPropertyDetails.electricityTariff') });
      Cols.push({ dataField: 'propInfoFlag1Data', caption: this.$t('enquiriesAccount.propInfoFlag1Data') });
      Cols.push({ dataField: 'propInfoFlag2Data', caption: this.$t('enquiriesAccount.propInfoFlag2Data') });
      Cols.push({ dataField: 'propInfoFlag3Data', caption: this.$t('enquiriesAccount.propInfoFlag3Data') });
      Cols.push({ dataField: 'propInfoFlag4Data', caption: this.$t('enquiriesAccount.propInfoFlag4Data') });
      Cols.push({ dataField: 'propInfoFlag5Data', caption: this.$t('enquiriesAccount.propInfoFlag5Data') });

      this.CustomerData.filter(a => a.idx == 'Properties')[0].Cols = Cols;
    },
    fillAccountApplicationsColumns() {
      this.CustomerData.filter(a => a.idx == 'AccountApplications')[0].Cols = [];

      let Cols = [];

      Cols.push({ dataField: 'sourceTypeS', caption: this.$t('enquiriesAccount.sourceTypeS') });
      Cols.push({ dataField: 'applicationId', caption: this.$t('enquiriesAccount.applicationId') });
      Cols.push({ dataField: 'applicationDate', caption: this.$t('enquiriesAccount.applicationDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      Cols.push({ dataField: 'applicationType', caption: this.$t('enquiriesAccount.applicationType') });
      Cols.push({ dataField: 'status', caption: this.$t('enquiriesAccount.status') });
      Cols.push({ dataField: 'propertyRef', caption: this.$t('enquiriesAccount.propertyRef') });
      Cols.push({ dataField: 'address', caption: this.$t('enquiriesAccount.address') });
      Cols.push({ dataField: 'hasDigitalSignatures', caption: this.$t('enquiriesAccount.hasDigitalSignatures') });
      Cols.push({ dataField: 'stampUser', caption: this.$t('enquiries.stampUser') });

      this.CustomerData.filter(a => a.idx == 'AccountApplications')[0].Cols = Cols;
    },
    fillPropertyApplicationsColumns() {
      this.CustomerData.filter(a => a.idx == 'PropertiesApplications')[0].Cols = [];

      let Cols = [];

      Cols.push({ dataField: 'applicationId', caption: this.$t('enquiriesAccount.applicationId') });
      Cols.push({ dataField: 'applicationDate', caption: this.$t('enquiriesAccount.applicationDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      Cols.push({ dataField: 'applicationType', caption: this.$t('enquiriesAccount.applicationType') });
      Cols.push({ dataField: 'status', caption: this.$t('enquiriesAccount.status') });
      Cols.push({ dataField: 'comment', caption: this.$t('enquiriesAccount.comment') });
      Cols.push({ dataField: 'hasDigitalSignatures', caption: this.$t('enquiriesAccount.hasDigitalSignatures') });
      Cols.push({ dataField: 'stampUser', caption: this.$t('enquiries.stampUser') });

      this.CustomerData.filter(a => a.idx == 'PropertiesApplications')[0].Cols = Cols;
    },
    fillDmCasesColumns() {
      this.CustomerData.filter(a => a.idx == 'DmCases')[0].Cols = [];

      let Cols = [];

      Cols.push({ dataField: 'custkey', caption: this.$t('enquiriesAccount.custkey') });
      Cols.push({ dataField: 'accountName', caption: this.$t('enquiriesAccount.accountName') });
      Cols.push({ dataField: 'caseId', caption: this.$t('enquiriesAccount.caseId') });
      Cols.push({ dataField: 'activeCase', caption: this.$t('enquiriesAccount.activeCase') });
      Cols.push({ dataField: 'activityStage', caption: this.$t('enquiriesAccount.activityStage') });
      Cols.push({ dataField: 'openDate', caption: this.$t('enquiriesAccount.openDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });

      this.CustomerData.filter(a => a.idx == 'DmCases')[0].Cols = Cols;
    },
    fillDmAgreementsColumns() {
      this.CustomerData.filter(a => a.idx == 'DmAgreements')[0].Cols = [];

      let Cols = [];

      Cols.push({ dataField: 'agreementTypeDisplay', caption: this.$t('activities.agreementType') });
      //Cols.push({ dataField: 'custkey', caption: this.$t('enquiriesAccount.custkey') });
      //Cols.push({ dataField: 'accountName', caption: this.$t('enquiriesAccount.accountName') });
      Cols.push({ dataField: 'reference', caption: this.$t('enquiriesAccount.reference') });
      Cols.push({ dataField: 'effectiveDate', caption: this.$t('enquiriesAccount.effectiveDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      Cols.push({ dataField: 'agreemAmountS', caption: this.$t('enquiriesAccount.agreemAmountS') });
      Cols.push({ dataField: 'immediatePaymentS', caption: this.$t('enquiriesAccount.immediatePaymentS') });
      Cols.push({ dataField: 'installmentAmountS', caption: this.$t('enquiriesAccount.installmentAmountS') });
      Cols.push({ dataField: 'instNo', caption: this.$t('enquiriesAccount.instNo') });
      Cols.push({ dataField: 'lastInstalment', caption: this.$t('enquiriesAccount.lastInstalment'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      Cols.push({ dataField: 'restInstallments', caption: this.$t('enquiries.restInstallments') });
      Cols.push({ dataField: 'calculatedStatusS', caption: this.$t('enquiriesAccount.calculatedStatusS') });

      this.CustomerData.filter(a => a.idx == 'DmAgreements')[0].Cols = Cols;
    },
    fillDmInvestigationsColumns() {
      this.CustomerData.filter(a => a.idx == 'DmInvestigations')[0].Cols = [];

      let Cols = [];

      Cols.push({ dataField: 'custkey', caption: this.$t('enquiriesAccount.custkey') });
      Cols.push({ dataField: 'accountName', caption: this.$t('enquiriesAccount.accountName') });
      Cols.push({ dataField: 'sourceS', caption: this.$t('enquiriesAccount.sourceS') });
      Cols.push({ dataField: 'id', caption: this.$t('enquiriesAccount.id') });
      Cols.push({ dataField: 'statusS', caption: this.$t('enquiriesAccount.status') });
      Cols.push({ dataField: 'investigationDate', caption: this.$t('enquiriesAccount.investigationDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      Cols.push({ dataField: 'completionDate', caption: this.$t('enquiriesAccount.completionDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      Cols.push({ dataField: 'documentNo', caption: this.$t('enquiriesAccount.documentNo') });

      this.CustomerData.filter(a => a.idx == 'DmInvestigations')[0].Cols = Cols;
    },
    fillDepositsColumns() {
      this.CustomerData.filter(a => a.idx == 'Deposits')[0].Cols = [];

      let Cols = [];

      if (this.BillingMasterCustomer) {
        Cols.push({ dataField: 'custkey', caption: this.$t('enquiriesAccount.custkey') });
        Cols.push({ dataField: 'accountName', caption: this.$t('enquiriesAccount.accountName') });
      } else {
        Cols.push({ dataField: 'property', caption: this.$t('enquiriesAccount.property') });
      }

      Cols.push({ dataField: 'amount', caption: this.$t('enquiriesAccount.amount') });
      Cols.push({ dataField: 'refunded', caption: this.$t('enquiriesAccount.refunded') });
      Cols.push({ dataField: 'balance', caption: this.$t('enquiriesAccount.balance') });
      Cols.push({ dataField: 'comment', caption: this.$t('enquiriesAccount.comment') });
      Cols.push({ dataField: 'bankName', caption: this.$t('enquiriesAccount.BankName') });
      Cols.push({ dataField: 'bankAddress', caption: this.$t('enquiriesAccount.BankAddress') });
      Cols.push({ dataField: 'bankEmail', caption: this.$t('enquiriesAccount.BankEmail') });
      Cols.push({ dataField: 'receiptNo', caption: this.$t('receipting.receiptNo') });
      Cols.push({ dataField: 'applFormNo', caption: this.$t('enquiriesAccount.CsAppsNo') });
      Cols.push({ dataField: 'submitDate', caption: this.$t('enquiriesAccount.SubmittedOn'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      Cols.push({ dataField: 'expiryDate', caption: this.$t('activities.expiryDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      Cols.push({ dataField: 'comments', caption: this.$t('enquiriesCustomerDetails.comments') });

      this.CustomerData.filter(a => a.idx == 'Deposits')[0].Cols = Cols;
    },
    fillPropertyHistoryColumns() {
      this.CustomerData.filter(a => a.idx == 'PropertyHistory')[0].Cols = [];

      let Cols = [];

      Cols.push({ dataField: 'docNo', caption: this.$t('enquiriesAccount.docNo') });
      Cols.push({ dataField: 'details', caption: this.$t('enquiriesAccount.details') });
      Cols.push({ dataField: 'date', caption: this.$t('enquiriesAccount.date') });
      Cols.push({ dataField: 'ownerCustkey', caption: this.$t('enquiriesAccount.ownerCustkey') });
      Cols.push({ dataField: 'ownerName', caption: this.$t('enquiriesAccount.ownerName') });
      Cols.push({ dataField: 'tenantCustkey', caption: this.$t('enquiriesAccount.tenantCustkey') });
      Cols.push({ dataField: 'tenantName', caption: this.$t('enquiriesAccount.tenantName') });

      this.CustomerData.filter(a => a.idx == 'PropertyHistory')[0].Cols = Cols;
    },
    fillConnectionHistoryColumns() {
      this.CustomerData.filter(a => a.idx == 'ConnectionHistory')[0].Cols = [];

      let Cols = [];

      Cols.push({ dataField: 'custkey', caption: this.$t('enquiriesAccount.custkey') });
      Cols.push({ dataField: 'accountName', caption: this.$t('enquiriesAccount.accountName') });
      Cols.push({ dataField: 'date', caption: this.$t('enquiriesAccount.date'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      Cols.push({ dataField: 'meter', caption: this.$t('enquiriesAccount.meter') });
      Cols.push({ dataField: 'reading', caption: this.$t('enquiriesAccount.reading') });
      Cols.push({ dataField: 'disconnection', caption: this.$t('enquiriesAccount.disconnection') });
      Cols.push({ dataField: 'reconnecton', caption: this.$t('enquiriesAccount.reconnecton') });
      Cols.push({ dataField: 'balance', caption: this.$t('enquiriesAccount.amountDue') });
      Cols.push({ dataField: 'applicationId', caption: this.$t('enquiriesAccount.applicationId') });
      Cols.push({ dataField: 'dmCaseId', caption: this.$t('enquiriesAccount.dmCaseId') });

      this.CustomerData.filter(a => a.idx == 'ConnectionHistory')[0].Cols = Cols;
    },
    fillUnbilledTransactionsColumns() {
      this.CustomerData.filter(a => a.idx == 'UnbilledTransactions')[0].Cols = [];
      this.statmTransactions.Cols = [];
      //this.CustomerData.filter(a => a.idx == 'Statements')[0].sub[0].cols = [];

      let Cols = [];
      Cols.push({ dataField: 'custkey', caption: this.$t('enquiriesAccount.custkey') });
      Cols.push({ dataField: 'accountName', caption: this.$t('enquiriesAccount.accountName') });
      Cols.push({ dataField: 'effectiveDate', caption: this.$t('enquiriesAccount.date'), dataType: 'date' });
      Cols.push({ dataField: 'transNoAbs', caption: this.$t('enquiriesAccount.transNo') });
      Cols.push({ dataField: 'transactionType', caption: this.$t('enquiriesAccount.type') });
      Cols.push({ dataField: 'transactionDescription', caption: this.$t('enquiriesAccount.description') });
      Cols.push({ dataField: 'documentNo', caption: this.$t('enquiriesAccount.documentNo') });
      Cols.push({ dataField: 'currentReading', caption: this.$t('enquiriesAccount.reading') });
      Cols.push({ dataField: 'consumption', caption: this.$t('enquiriesAccount.consumption') });
      Cols.push({ dataField: 'debit', caption: this.$t('enquiriesAccount.debit') });
      Cols.push({ dataField: 'credit', caption: this.$t('enquiriesAccount.credit') });
      Cols.push({ dataField: 'vatAmountS', caption: this.$t('enquiriesAccount.vat') });
      Cols.push({ dataField: 'balanceS', caption: this.$t('enquiriesAccount.balance') });
      Cols.push({ dataField: 'statementNoAbs', caption: this.$t('enquiriesAccount.statementNo') });
      Cols.push({ dataField: 'billingDate', caption: this.$t('enquiriesAccount.statementDate'), dataType: 'date' });
      Cols.push({ dataField: 'propertyRef', caption: this.$t('enquiriesAccount.propertyRef') });
      Cols.push({ dataField: 'meterRef', caption: this.$t('enquiriesAccount.meterRef') });
      Cols.push({ dataField: 'glBatchNo', caption: this.$t('enquiriesAccount.batchNo') });
      Cols.push({ dataField: 'consumptionTypeS', caption: this.$t('enquiriesAccount.consumptionType') });
      Cols.push({ dataField: 'revTransNoAbs', caption: this.$t('enquiriesAccount.revTransNo') });
      Cols.push({ dataField: 'stampUser', caption: this.$t('enquiriesAccount.stampUser') });
      Cols.push({ dataField: 'stampDate', caption: this.$t('enquiriesAccount.stampDate'), dataType: 'date' });
      //Cols.push({ dataField: 'custkey', caption: this.$t('enquiriesAccount.custkey') });

      this.CustomerData.filter(a => a.idx == 'UnbilledTransactions')[0].Cols = [...Cols];

      Cols = [];

      //Cols.push({ dataField: 'effectiveDate', caption: this.$t('enquiriesAccount.date'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      //Cols.push({ dataField: 'transactionType', caption: this.$t('enquiriesAccount.type') });
      //Cols.push({ dataField: 'transactionDescription', caption: this.$t('enquiriesAccount.description') });
      //Cols.push({ dataField: 'debit', caption: this.$t('enquiriesAccount.debit') });
      //Cols.push({ dataField: 'credit', caption: this.$t('enquiriesAccount.credit') });
      //Cols.push({ dataField: 'vatAmount', caption: this.$t('enquiriesAccount.vat') });

      Cols.push({ dataField: 'transNoAbs', caption: this.$t('enquiriesCustomerDetails.transNo') });
      Cols.push({ dataField: 'transactionType', caption: this.$t('enquiriesCustomerDetails.type') });
      Cols.push({ dataField: 'effectiveDate', caption: this.$t('enquiriesCustomerDetails.date'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      Cols.push({ dataField: 'transactionDescription', caption: this.$t('enquiriesCustomerDetails.description') });
      Cols.push({ dataField: 'documentNo', caption: this.$t('enquiriesCustomerDetails.documentRef') });
      Cols.push({ dataField: 'debit', caption: this.$t('enquiriesCustomerDetails.debit') });
      Cols.push({ dataField: 'credit', caption: this.$t('enquiriesCustomerDetails.credit') });
      Cols.push({ dataField: 'vatAmountS', caption: this.$t('enquiriesCustomerDetails.vat') });
      Cols.push({ dataField: 'balanceS', caption: this.$t('enquiriesCustomerDetails.balance') });
      Cols.push({ dataField: 'currentReadingS', caption: this.$t('enquiriesCustomerDetails.reading') });
      Cols.push({ dataField: 'consumption', caption: this.$t('enquiriesCustomerDetails.consumption') });
      Cols.push({ dataField: 'statementNoAbs', caption: this.$t('enquiriesCustomerDetails.statementNo') });
      Cols.push({ dataField: 'billingDate', caption: this.$t('enquiriesCustomerDetails.statementDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      Cols.push({ dataField: 'propertyRef', caption: this.$t('enquiriesCustomerDetails.propertyRef') });
      Cols.push({ dataField: 'meterRef', caption: this.$t('enquiriesCustomerDetails.meterRef') });
      Cols.push({ dataField: 'glBatchNo', caption: this.$t('enquiriesCustomerDetails.batchNo') });
      Cols.push({ dataField: 'consumptionTypeS', caption: this.$t('enquiriesCustomerDetails.consumptionType') });
      Cols.push({ dataField: 'revTransNoAbs', caption: this.$t('enquiriesCustomerDetails.revTransNo') });
      Cols.push({ dataField: 'stampUser', caption: this.$t('enquiriesCustomerDetails.stampUser') });


      this.statmTransactions.Cols = Cols;
      //this.CustomerData.filter(a => a.idx == 'Statements')[0].sub[0].cols = Cols;
    },
    fillStatementsColumns() {
      this.CustomerData.filter(a => a.idx == 'Statements')[0].Cols = [];

      let Cols = [];
      Cols.push({ dataField: 'account', caption: this.$t('enquiriesAccount.custkey') });
      Cols.push({ dataField: 'customerName', caption: this.$t('enquiriesAccount.accountName') });
      Cols.push({ dataField: 'statementDate', caption: this.$t('enquiriesAccount.BillingDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      Cols.push({ dataField: 'statementNoAbs', caption: this.$t('enquiriesAccount.statementNo') });
      Cols.push({ dataField: 'paymentNo', caption: this.$t('enquiriesAccount.invoiceNo') });
      Cols.push({ dataField: 'balance', caption: this.$t('enquiriesAccount.balance') });
      Cols.push({ dataField: 'payBy', caption: this.$t('enquiriesAccount.payBy'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      Cols.push({ dataField: 'emailSent', caption: this.$t('enquiriesAccount.emailSent'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYYYHHmm });
      Cols.push({ dataField: 'smsSent', caption: this.$t('enquiriesAccount.smsSent'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYYYHHmm });      
      Cols.push({ dataField: 'paymentMethodName', caption: this.$t('enquiriesAccount.paymentMethod') });   
     
      this.CustomerData.filter(a => a.idx == 'Statements')[0].Cols = Cols;
    },
    fillPlotsColumns() {
      this.CustomerData.filter(a => a.idx == 'Plots')[0].Cols = [];

      let Cols = [];

      Cols.push({ dataField: 'plotNo', caption: this.$t('enquiriesAccount.plotNo') });
      Cols.push({ dataField: 'gisKey', caption: this.$t('enquiriesAccount.key') });
      Cols.push({ dataField: 'town', caption: this.$t('enquiriesAccount.town') });
      Cols.push({ dataField: 'township', caption: this.$t('enquiriesAccount.township') });

      this.CustomerData.filter(a => a.idx == 'Plots')[0].Cols = Cols;
    },
    fillReadingsColumns() {
      this.CustomerData.filter(a => a.idx == 'Readings')[0].Cols = [];

      let Cols = [];

      Cols.push({ dataField: 'meterRef', caption: this.$t('enquiriesAccount.meterRef') });
      Cols.push({ dataField: 'readingNoAbs', caption: this.$t('enquiriesAccount.no') });
      Cols.push({ dataField: 'rdgDate', caption: this.$t('enquiriesAccount.date'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      Cols.push({ dataField: 'noOfDays', caption: this.$t('enquiriesAccount.noOfDays') });
      Cols.push({ dataField: 'reading', caption: this.$t('enquiriesAccount.reading') });
      Cols.push({ dataField: 'calculatedConsumption', caption: this.$t('enquiriesAccount.calculatedConsumption') });
      Cols.push({ dataField: 'modifiedConsumption', caption: this.$t('enquiriesAccount.modifiedConsumption') });
      Cols.push({ dataField: 'diffFromMainConsumption', caption: this.$t('enquiriesAccount.diffFromMainConsumption') });
      Cols.push({ dataField: 'consumption', caption: this.$t('enquiriesAccount.totalConsumption') });
      Cols.push({ dataField: 'flow', caption: this.$t('enquiriesAccount.flow') });
      Cols.push({ dataField: 'clockOver', caption: this.$t('enquiriesAccount.clockOver') });
      Cols.push({ dataField: 'isCancelled', caption: this.$t('enquiriesAccount.cancelled') });
      Cols.push({ dataField: 'typeDescription', caption: this.$t('enquiriesAccount.type') });
      Cols.push({ dataField: 'reasonDescription', caption: this.$t('enquiriesAccount.reason') });
      Cols.push({ dataField: 'methodDescription', caption: this.$t('enquiriesAccount.readingMethod') });
      Cols.push({ dataField: 'noteCode', caption: this.$t('enquiriesAccount.note') });
      Cols.push({ dataField: 'accessCode', caption: this.$t('enquiriesAccount.access') });
      Cols.push({ dataField: 'comment', caption: this.$t('enquiriesAccount.comment') });
      Cols.push({ dataField: 'isInvoiced', caption: this.$t('enquiriesAccount.billed') });
      Cols.push({ dataField: 'invoiceDate', caption: this.$t('enquiriesAccount.billingDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });

      this.CustomerData.filter(a => a.idx == 'Readings')[0].Cols = Cols;
    },
    fillTransactionsColumns() {
      this.CustomerData.filter(a => a.idx == 'Transactions')[0].Cols = [];

      let Cols = [];
      Cols.push({ dataField: 'custkey', caption: this.$t('enquiriesAccount.custkey') });
      Cols.push({ dataField: 'accountName', caption: this.$t('enquiriesAccount.accountName') });
      Cols.push({ dataField: 'transNoAbs', caption: this.$t('enquiriesCustomerDetails.transNo') });
      Cols.push({ dataField: 'transactionType', caption: this.$t('enquiriesCustomerDetails.type') });
      Cols.push({ dataField: 'effectiveDate', caption: this.$t('enquiriesCustomerDetails.date'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      Cols.push({ dataField: 'transactionDescription', caption: this.$t('enquiriesCustomerDetails.description') });
      Cols.push({ dataField: 'documentNo', caption: this.$t('enquiriesCustomerDetails.documentRef') });
      Cols.push({ dataField: 'debit', caption: this.$t('enquiriesCustomerDetails.debit') });
      Cols.push({ dataField: 'credit', caption: this.$t('enquiriesCustomerDetails.credit') });
      Cols.push({ dataField: 'vatAmountS', caption: this.$t('enquiriesCustomerDetails.vat') });
      Cols.push({ dataField: 'balanceS', caption: this.$t('enquiriesCustomerDetails.balance') });
      Cols.push({ dataField: 'currentReadingS', caption: this.$t('enquiriesCustomerDetails.reading') });
      Cols.push({ dataField: 'consumption', caption: this.$t('enquiriesCustomerDetails.consumption') });
      Cols.push({ dataField: 'statementNoAbs', caption: this.$t('enquiriesCustomerDetails.statementNo') });
      Cols.push({ dataField: 'billingDate', caption: this.$t('enquiriesCustomerDetails.statementDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      Cols.push({ dataField: 'propertyRef', caption: this.$t('enquiriesCustomerDetails.propertyRef') });
      Cols.push({ dataField: 'meterRef', caption: this.$t('enquiriesCustomerDetails.meterRef') });
      Cols.push({ dataField: 'glBatchNo', caption: this.$t('enquiriesCustomerDetails.batchNo') });
      Cols.push({ dataField: 'consumptionTypeS', caption: this.$t('enquiriesCustomerDetails.consumptionType') });
      Cols.push({ dataField: 'revTransNoAbs', caption: this.$t('enquiriesCustomerDetails.revTransNo') });
      Cols.push({ dataField: 'stampUser', caption: this.$t('enquiriesCustomerDetails.stampUser') });
      Cols.push({ dataField: 'stampDate', caption: this.$t('enquiriesCustomerDetails.stampDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });

      this.CustomerData.filter(a => a.idx == 'Transactions')[0].Cols = Cols;
    },
    openTab(id) {
      this.selectedTab = id;
    },
    getLastReadingData() {
      this.lastReadingDate = this.CustomerData.filter(a => a.idx == 'Readings')[0].Data.length == 0 ? '' :
        moment(this.CustomerData.filter(a => a.idx == 'Readings')[0].Data[0].rdgDate).format('DD/MM/YYYY');

      this.lastReading = this.CustomerData.filter(a => a.idx == 'Readings')[0].Data.length == 0 ? '' :
        this.CustomerData.filter(a => a.idx == 'Readings')[0].Data[0].reading.toString();
    },
    getLastInvoiceData() {
      this.lastInvoiveIssueDate = this.CustomerData.filter(a => a.idx == 'Statements')[0].Data.length == 0 ? '' :
        moment(this.CustomerData.filter(a => a.idx == 'Statements')[0].Data[0].statementDate).format('DD/MM/YYYY');

      this.lastInvoiveIssueAmount = this.CustomerData.filter(a => a.idx == 'Statements')[0].Data.length == 0 ? '' :
        this.CustomerData.filter(a => a.idx == 'Statements')[0].Data[0].balance.toString();
    },
    getCustomerReports() {
      axios.get('/Enquiries/GetCustomerReports')
        .then(response => {
          if (response.status == 200) {
            this.customerReports = response.data;
          }
        })
        .catch(err => {
          this.$oldAlertMsg(err.response.data);
        });
    },
    getGeneralReports() {
      axios.get('/Enquiries/GetGeneralReports')
        .then(response => {
          if (response.status == 200) {
            this.generalReports = response.data;
          }
        })
        .catch(err => {
          this.$oldAlertMsg(err.response.data);
        });
    },
    printGeneralReport(reportId) {
      axios.post('/Enquiries/CreateGeneralReport?reportId=' + reportId)
        .then(response => {
          if (response.status == 200) {
            window.open(response.data, '_blank');
          }
          else
            this.$oldAlertMsg(response.data.data.text)
        })
        .catch(err => err.data == undefined ? this.$oldAlertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$oldAlertMsg(err.data.data.text)
        );
    },
    printCustomerReport(reportId) {
      axios.post('/Enquiries/CreateCustomerReport?reportId=' + reportId + '&custkey=' + this.customerAllData.custkey)
        .then(response => {
          if (response.status == 200) {
            window.open(response.data, '_blank');
          }
          else
            this.$oldAlertMsg(response.data.data.text)
        })
        .catch(err => err.data == undefined ? this.$oldAlertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$oldAlertMsg(err.data.data.text)
        );
    },
    openMainConnectionDetails() {
      let routeData = this.$router.resolve({ name: 'connectionDetails', params: { ConnectionId: this.customerAllData.connection.mainConnId } });
      window.open(routeData.href, '_blank');
    },
    getSubConnections() {
      if (this.customerAllData.connection == null)
        return;

      axios.get('/Enquiries/getSubConnections?connId=' + this.customerAllData.connection.connectionId)
        .then(response => {
          if (response.data.data.status == 0) {
            this.subCons = response.data.items;
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed(e);
          this.$oldAlertMsg(e, 4);
          return false;
        })
    },
    viewSubConnDetails(id) {
      let routeData = this.$router.resolve({ name: 'connectionDetails', params: { ConnectionId: id } });
      window.open(routeData.href, '_blank');
    },
    showApplicationDetails(info) {
      //old app type do not open
      if (info.data.sourceType == 1) {
        this.$oldAlertMsg(this.$t('enquiries.cantOpenOldApp'));
        return;
      }

      let routeData = this.$router.resolve({ name: 'showApplication', params: { id: info.data.applicationId } });
      window.open(routeData.href, '_blank');
    },
    getAgreemInstallments(info) {
      if (info != undefined) {
        this.selectedAgreemNo = info.rows[info.newRowIndex].data.agreemNo;
      }
    },
    getQueries() {
      if (this.offlineModeState)
        return;

      axios.get('/CustomQuery/GetQueries?locationId=10')
        .then(response => {
          if (response.status == 200) {
            if (response.data == null)
              this.queries = [];
            else
              this.queries = response.data;
          }
        })
        .catch(err => {
          this.getDataFailed();
          err.data == undefined ? this.$oldAlertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
            this.$oldAlertMsg(err.data.data.text)
        })
    },


    dmCaseSelected(item) {
      //console.log(item)
    },
  },
}
